const socialMediaLinks = {
  facebook: "/",
  twitter: "/",
  linkedin: "/",
};

export default socialMediaLinks;
